<div class="createLinkDialog">
    <sync-dialog *ngIf="isComponentInitialized && isVerified" [config]="{
        title: dialogTitle,
        subTitle: fileName,
        isClosable: true,
        onCloseIcon: onBack,
        actionButton: !isLoading && errcode?.code !== 8028 ? 'Create' : '',
        cancelButton: !isLoading && errcode?.code !== 8028 ? 'Cancel' : 'Close',
        onActionClick: createLink,
        onCancelClick: closeCreateLinkDialog,
        isActionButtonDisabled: isActionButtonDisabled,
    }" [open]="showCreateLinkDialog" [isFullScreen]="false" [onClose]="closeCreateLinkDialog">
        <app-error
            *ngIf="errcode"
            [errcode]="errcode"
        ></app-error>
        <div class="link-create-container" *ngIf="linkForm && !errcode" [formGroup]="linkForm">
            <div class="loading-state" *ngIf="isLoading">
                <sync-spinner></sync-spinner>
                <p class="subtitle-1">{{modalText}}</p>
            </div>
            <app-permissions-link-form
                *ngIf="!isLoading"
                formControlName="permissionsForm"
                [link]="link"
                [fileType]="fileType"
                [item]="item">
            </app-permissions-link-form>
        </div>
    </sync-dialog>

    <app-verify-email-required *ngIf="isComponentInitialized && !isVerified" [cancelButtonText]="'Close'" (showDialogChange)="closeCreateLinkDialog()"
     [message]="'Your account must be verified in order to create a link.'"></app-verify-email-required>
</div>